
import AuditKendaraanEditorMain from "../../features/audit-kendaraan/audit-kendaraan-mobil/audit-kendaraan-mobil-editor/component/AuditKendaraanEditorMain";

const AuditKendaraanEditorPage = () => {
  return <AuditKendaraanEditorMain />;
};

export default AuditKendaraanEditorPage;
